export const BRAND_ID = '871B96D7-FC9D-46F1-9807-BF5C3A77890B';

